import type { AccessPair } from '@/shared/lib'

/**
 * Пара прав каталога `/v1/catalog/**` — зеркало `CATALOG_ACTING` бэка
 * (`src/catalog/catalog.controller.ts`): клиент — свой вид, менеджер без модификатора —
 * полный вид, с `client` или `cart` — глазами клиента.
 */
export const CATALOG_ACCESS: AccessPair = {
  own: 'catalog.view',
  onBehalf: 'catalog.view-as-client',
  full: 'catalog.view-all',
  accepts: ['account', 'unp', 'settlement', 'cart'],
}
